exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-table__row,th,.el-tag{font-size:13px !important}.flex{display:-webkit-box;display:-ms-flexbox;display:flex}.justify-between{-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.items-center{-webkit-box-align:center;-ms-flex-align:center;align-items:center}.template-id{visibility:hidden}.el-table__row:hover .template-id{visibility:visible}", ""]);

// exports
